import { getIconProps, type IconProps } from '#types'

/**
 * Hourglass / sand-clock icon.
 *
 * Used for duration selection in booking flows and time-pending indicators.
 */
export function HourglassIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M6 3H19M6 21H19M6.92857 3V6.6C6.92857 9.58234 9.42299 12 12.5 12M18.0714 21V17.4C18.0714 14.4177 15.577 12 12.5 12M12.5 12C9.42299 12 6.92857 14.4177 6.92857 17.4V21M12.5 12C15.577 12 18.0714 9.58234 18.0714 6.6V3M15.2857 6.6C15.2857 8.09117 14.0385 9.3 12.5 9.3C10.9615 9.3 9.71429 8.09117 9.71429 6.6"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
